import React, { useEffect, useState } from 'react';
import ForgotPassword from './Components/ForgotPassword/ForgotPassword';
import LoginByMobileNumber from './Components/LoginByMobileNumber/LoginByMobileNumber';
import LoginHeader from './Components/LoginHeader/LoginHeader';
import NormalLogin from './Components/NormalLogin/NormalLogin';
import PasswordResetTrigger from './Components/PasswordResetTrigger/PasswordResetTrigger';
import useControlPasswordReset from './Hooks/useControlPasswordReset';
import styles from './Styles/Login.Forms.module.scss';
import i18next from 'i18next';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { Container } from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useAtom } from 'jotai';
import { getPrefrenceTrigger } from 'Global/shared/get.prefrence.trigger.atom';
import useGetMainConfig from 'Global/Hooks/useGetMainConfig';
import HtmlParser from 'react-html-parser';

const UserInterFace = () => {
  const copyright_label = FindLangKey(
    'general-public-copyright-notice'
  );
  const nobatPrefrences = useGetMainConfig(true);

  // console.log('nobatPrefrences->', nobatPrefrences);

  const webAppPrefrences =
    useContext(GlobalContext)?.appConfig;

  const enamadLink = webAppPrefrences?.filter(
    (fl) => fl.Key === 'WebAppEnamadURL'
  )[0]?.Value;

  const [prefrences, setPrefrences] = useState(() =>
    nobatPrefrences ||
    localStorage.getItem('nobat_prefrence')
      ? JSON.parse(localStorage.getItem('nobat_prefrence'))
      : ''
  );

  useEffect(() => {
    const item = localStorage.getItem('nobat_prefrence')
      ? JSON.parse(localStorage.getItem('nobat_prefrence'))
      : '';
    setPrefrences(nobatPrefrences || item);
  }, [nobatPrefrences]);

  const { ResetTrigger, SetResetTrigger } =
    useControlPasswordReset();

  const canRegister = prefrences
    ? prefrences?.filter(
        (fl) => fl.Key === 'webAppcanRegister'
      )[0]?.Value === 'True'
    : false;
  const canLoginByPhoneNumber = prefrences
    ? webAppPrefrences?.filter(
        (fl) => fl.Key === 'webAppLoginByMobile'
      )[0]?.Value === 'True'
    : false;

  const canResetPassword = prefrences
    ? webAppPrefrences?.filter(
        (fl) => fl.Key === 'webAppFaramoshiRamz'
      )[0]?.Value === 'True'
    : false;

  const signUpLink_label = FindLangKey(
    'login-link-sign-up'
  );

  const LoginOrLabel = FindLangKey(
    'login-label-or-seperator'
  );

  return (
    <React.Fragment>
      <LoginHeader />
      <Container
        maxWidth="sm"
        sx={{
          color: `${themeColors.ColorPrimary} !important`,
        }}
      >
        <div className={styles.loginSection}>
          {ResetTrigger ? (
            <ForgotPassword />
          ) : (
            <NormalLogin />
          )}
          {/* <Button
            color="info"
            variant="outlined"
            fullWidth
            sx={{ mt: "1em", minHeight: "40px" }}
            onClick={() => {
              navigate("/");
            }}
          >
            {FindLangKey("login-btn-login-as-guest")}
          </Button> */}
          {canResetPassword ? (
            <PasswordResetTrigger
              setter={SetResetTrigger}
              ResetTrigger={ResetTrigger}
            />
          ) : (
            <></>
          )}
          {canResetPassword ? (
            <p className={styles.orLine}>{LoginOrLabel}</p>
          ) : (
            <></>
          )}
          {canLoginByPhoneNumber ? (
            <LoginByMobileNumber />
          ) : (
            <></>
          )}
          <h5
            className={styles.SignUpNotation}
            dir="ltr"
            style={{
              textAlign:
                i18next?.language === 'en'
                  ? 'left'
                  : 'right',
            }}
          >
            {canRegister ? (
              <Link to="/Signup">{signUpLink_label}</Link>
            ) : (
              <></>
            )}
          </h5>
        </div>
        <div
          style={{
            backgroundColor: `${themeColors.ColorPrimary}`,
            width: '100%',
            height: '4.5em',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            color: `${themeColors.ColorSecondary}`,
            textAlign: 'center',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row-reverse',
            gap: '2em',
            fontSize: '0.8em',
          }}
        >
          <p style={{ textAlign: 'center' }}>
            {/* © {new Date().getFullYear()}  */}
            {copyright_label}
          </p>
          {HtmlParser(enamadLink)}
        </div>
      </Container>
    </React.Fragment>
  );
};

export default UserInterFace;
